import React, { useMemo } from "react";
import "./Disclaimer.css";
import { useLocalContext } from "../../context/LocalContext";

const Disclaimer = () => {
  const { webinfo = {} } = useLocalContext();

  const brand = useMemo(
    () => ({
      name: webinfo.name || "Your Brand",
      email: webinfo.email || "hello@example.com",
      phone: webinfo.phone || "+91 80000 00000",
      phonecall: webinfo.phonecall || "+918000000000",
      address: webinfo.address || "Remote-first • Serving clients worldwide",
    }),
    [webinfo]
  );

  const effectiveDate = useMemo(
    () =>
      new Date().toLocaleDateString(undefined, {
        year: "numeric",
        month: "long",
        day: "numeric",
      }),
    []
  );

  return (
    <section className="disclaimerv2">
      <div className="dv2-wrap">
        {/* Header */}
        <header className="privacy-policy-header">
          <p className="pp-eyebrow">Important Notice</p>
          <div className="pp-header-main">
            <h1>Website Disclaimer</h1>
          </div>
          <p className="pp-meta">
            <span>Issued by: {brand.name}</span>
            <span>Last updated: {effectiveDate}</span>
          </p>
        </header>

        {/* Content */}
        <div className="privacy-policy-content">
          {[
            {
              title: "1. Informational purposes only",
              text: `All information on this website is published in good faith and for
              general informational and educational purposes only. While ${brand.name} endeavours to keep information accurate and
              up to date, we make no representations or warranties of any kind
              about completeness, reliability, suitability, or availability.
              Content may be updated, corrected, or removed at any time without
              notice.`,
            },
            {
              title: "2. No professional advice",
              text: `Nothing on this website should be considered professional advice,
              including marketing, technical, legal, financial, tax, or business advice. Any examples, checklists,
              templates, or recommendations shared are generic in nature and may
              not fit your specific situation. Before making decisions that could affect your business, finances,
              or legal position, you should consult with a qualified professional
              who understands your circumstances. Any actions you take based on
              this website are strictly at your own risk.`,
            },
            {
              title: "3. Results & performance disclaimers",
              text: `Any case studies, testimonials, performance screenshots, or
              results we share are examples of individual projects carried out
              under specific conditions. They do not guarantee that you will
              achieve the same or similar outcomes. Results in areas such as rankings, traffic, conversions, revenue,
              or lead volume are influenced by many variables outside our
              control, including competition, budgets, market conditions,
              internal processes, and implementation quality.`,
            },
            {
              title: "4. Use of AI & automation tools",
              text: `From time to time ${brand.name} may use reputable AI and automation
              tools to support tasks such as research, ideation, drafting, QA,
              or optimization. While we aim to review and refine outputs before
              publishing, AI-generated content may contain inaccuracies or
              limitations. You should not treat any information generated with the assistance
              of AI as legal, financial, or tax advice, and you remain
              responsible for verifying the suitability of any content for your
              own use.`,
            },
            {
              title: "5. External links",
              text: `Our website may include links to third-party websites, tools,
              articles, or platforms. These links are provided purely for
              convenience or reference. ${brand.name} has no control over the
              content, policies, or availability of external sites and does not
              endorse or guarantee any information, products, or services they
              provide. Visiting external sites via links from our website is at your own
              discretion and risk.`,
            },
            {
              title: "6. Platforms, policies & compliance",
              text: `${brand.name} is not responsible for account restrictions,
              disapprovals, suspensions, or compliance issues arising from your
              business model, content, historic activity, or platform policy
              changes, even where we have provided guidance or implementation
              support.`,
            },
            {
              title: "7. Limitation of liability",
              text: `To the fullest extent permitted by law, ${brand.name} and its team
              disclaim all liability for any direct, indirect, incidental,
              consequential, or special damages arising out of or in connection
              with your use of this website, reliance on any information
              provided, or inability to access the site. This includes, without limitation, loss of profits, business, data,
              goodwill, or other intangible losses, even if we have been advised
              of the possibility of such damages.`,
            },
            {
              title: "8. Accuracy, uptime & availability",
              text: `While we aim to provide a secure, reliable, and smooth experience,
              we do not warrant that the website will always be available,
              error-free, secure, or uninterrupted. Technical issues, scheduled
              maintenance, third-party outages, or other factors may temporarily
              affect access. ${brand.name} will not be liable for any loss or damage resulting
              from downtime, errors, or interruptions.`,
            },
            {
              title: "9. Changes to this Disclaimer",
              text: `We may update, amend, or replace this Disclaimer from time to time
              to reflect changes in our practices, tools, or applicable law. The
              “Last updated” date at the top of this page indicates the latest
              version. Your continued use of the website after any changes have been
              posted will be taken as acceptance of the updated Disclaimer.`,
            },
            {
              title: "10. Contact us",
              text: (
                <>
                  If you have questions or concerns about this Disclaimer, or would
                  like clarification on how it applies to your use of our website,
                  please reach out using the details below:
                  <ul className="pp-contact-list">
                    <li>
                      <strong>Email:</strong>{" "}
                      <a href={`mailto:${brand.email}`}>{brand.email}</a>
                    </li>
                    <li>
                      <strong>Phone:</strong>{" "}
                      <a href={`tel:${brand.phonecall}`}>{brand.phone}</a>
                    </li>
                    <li>
                      <strong>Address:</strong> {brand.address}
                    </li>
                  </ul>
                </>
              ),
            },
          ].map((sec, idx) => (
            <section key={idx}>
              <h2>{sec.title}</h2>
              <p>{typeof sec.text === "string" ? sec.text : null}</p>
              {typeof sec.text !== "string" ? sec.text : null}
            </section>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Disclaimer;
